import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import LoginForm from '../components/Auth/LoginForm';
import { Card } from '../components/common';
import { BRAND_LOGO_FULL_SRC } from '../config/brandAssets';
import { savePostAuthIntentFromQueryValue } from '../utils/postAuthIntent';

const LoginPage: React.FC = () => {
  const location = useLocation();
  const emailPrefill = String((location.state as any)?.emailPrefill || '').trim();
  const onboardingHint = String((location.state as any)?.onboardingHint || '').trim();
  const suggestedRegisterPath = String((location.state as any)?.registerPath || '').trim();
  const registerPath =
    suggestedRegisterPath === '/register/service' ? '/register/service' : '/register/client';
  const from = (location.state as any)?.from;
  const queryParams = new URLSearchParams(location.search);
  const postAuthIntentFromQuery = queryParams.get('postAuthIntent');

  useEffect(() => {
    if (!postAuthIntentFromQuery) {
      return;
    }
    savePostAuthIntentFromQueryValue(postAuthIntentFromQuery, 'login-page-query');
  }, [postAuthIntentFromQuery]);

  const registerTarget = postAuthIntentFromQuery
    ? `${registerPath}?postAuthIntent=${postAuthIntentFromQuery}`
    : registerPath;

  return (
    <div className="flex min-h-screen flex-col bg-primary-dark-100">
      <div className="relative z-10 flex flex-1 flex-col items-center justify-center px-4 py-10">
        <div className="mb-8 text-center">
          <Link to="/" className="inline-block group focus-outline rounded-md">
            <img
              src={BRAND_LOGO_FULL_SRC}
              alt="Ratuj Sprzęt Logo"
              className="mx-auto mb-2 h-14 w-14 transition-opacity group-hover:opacity-90"
            />
            <h1 className="text-2xl font-display font-bold text-primary-light-100 group-hover:text-primary-light-200 transition-colors">
              Ratuj Sprzęt
            </h1>
          </Link>
        </div>

        <Card className="mb-8 w-full max-w-md animate-slide-up p-6 sm:p-8">
          <h2 className="text-xl font-bold text-primary-light-100 mb-6 text-center">Zaloguj się</h2>

          <LoginForm initialEmail={emailPrefill} initialHint={onboardingHint || undefined} />
        </Card>

        <p className="text-primary-light-300">
          Nie masz jeszcze konta?{' '}
          <Link
            to={registerTarget}
            state={from ? { from } : undefined}
            className="text-ratuj-300 hover:text-ratuj-200 font-medium focus-outline rounded"
          >
            Załóż konto
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
